// The Vue build version to load with the `import` command
// (runtime-only or standalone) has been set in webpack.base.conf with an alias.
//import vue from 'vue'
import router from './router'
//import element_ui from 'element-ui'
import '@@/assets/css/element-variables.scss'
//import 'element-ui/lib/theme-chalk/index.css'

//import swiper from 'vue-awesome-swiper'
//import 'swiper/dist/css/swiper.css'

import '@@/assets/css/theme.css'
import '@@/assets/js/apis.js'
import '@@/assets/js/lang.js'
import utils from '@/common/utils'
import req from '@/common/req'

import '@/common/geetest/gt'
//import '@/common/wechat/wxLogin'
Vue.use(VueAwesomeSwiper)

import app from '@@/pages/app/App'

//import * as vue_google_maps from 'vue2-google-maps'
var vue_upload_component = require('vue-upload-component')
Vue.component('file-upload', VueUploadComponent)

import qs from 'qs'

import store from '@@/assets/js/store';

Vue.prototype.dayjs = dayjs
Vue.prototype.qs = qs
Vue.prototype.store = store
Vue.prototype.math = math
//Vue.use(element_ui)
Vue.use(utils)
Vue.use(req)

Vue.config.productionTip = false

NProgress.configure({ showSpinner: false }) // NProgress Configuration

//不需要写public
window.UEDITOR_HOME_URL = process.env.NODE_ENV == "development" ? "/public/common/ueditor/" : "/" + process.env.VUE_APP_NAME.split("/")[1] + "/public/common/ueditor/"

//这里定义被选取模块,因为webpack无法识别@@，而又不想麻烦写全路径，所以统一导入，再用is动态引用


/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  components: {
    app,
    store
  },
  template: `<app></app>`,

  created: function () {
    document.title = "广东伟仕达电器科技有限公司"
    console.log(device)
    if (device.type === "mobile") {
      console.log("mobile")
      console.log(window.location.href)
      let url = window.location.href
      if (url.indexOf("/mobile") === -1) {
        window.location.href = "/mobile";
      }
    }
  },
  methods: {

  },
})
